import {
    BarChartIcon,
    CalendarDaysIcon,
    DatabaseIcon,
    FileTextIcon,
    HomeIcon,
    KeyRoundIcon,
    LayoutDashboardIcon,
    UsersIcon,
} from "lucide-react";
import { NavSection } from "@/lib/shadcn/components/sidebar/nav-platform";

export const adminSidebarItems: NavSection[] = [
    {
        title: "Platform",
        items: [
            {
                title: "Overview",
                url: "/admin/",
                icon: HomeIcon,
            },
            {
                title: "Daily Digest",
                url: "/admin/daily-digest",
                icon: CalendarDaysIcon,
            },
            {
                title: "Graphs",
                url: "/admin/graphs",
                icon: BarChartIcon,
                items: [
                    {
                        title: "Groups",
                        url: "/admin/graphs/groups",
                    },
                    {
                        title: "Apartments",
                        url: "/admin/graphs/apartments",
                    },
                    {
                        title: "Reviews",
                        url: "/admin/graphs/reviews",
                    },
                ],
            },
            {
                title: "Dashboards",
                url: "/admin/dashboards",
                icon: LayoutDashboardIcon,
                items: [
                    {
                        title: "Booking Pace",
                        url: "/admin/pace",
                    },
                    {
                        title: "Occupancy Explorer",
                        url: "/admin/occupancies",
                    },
                    {
                        title: "BLT Breakdown Analysis",
                        url: "/admin/blt-breakdown",
                    },
                    {
                        title: "Trends",
                        url: "/admin/trends",
                    },
                    {
                        title: "Payouts",
                        url: "/admin/payouts",
                    },
                    {
                        title: "Expenses",
                        url: "/admin/expenses-by-category",
                    },
                    {
                        title: "Host Performance per Unit",
                        url: "/admin/performance",
                    },
                ],
            },
            {
                title: "Database",
                url: "/admin/database",
                icon: DatabaseIcon,
                items: [
                    {
                        title: "Apartments",
                        url: "/admin/apartments",
                    },
                    {
                        title: "Rental Mapping",
                        url: "/admin/hosthub-mapping",
                    },
                    {
                        title: "Apartment Owners",
                        url: "/admin/owners",
                    },
                    {
                        title: "Reservations",
                        url: "/admin/reservations",
                    },
                    {
                        title: "Re-file review",
                        url: "/admin/refile-review",
                    },
                    {
                        title: "Sync issues",
                        url: "/admin/sync-issues",
                        // hosthub-event-durability/AS-013: the count is rentals whose
                        // ingestion is STUCK, not a queue of work — "3 pending" would
                        // mislead a screen-reader user.
                        badgeLabel: "wedged",
                    },
                    {
                        title: "Reconciliation",
                        url: "/admin/reconciliation",
                    },
                    {
                        title: "Expenses",
                        url: "/admin/expenses",
                    },
                    {
                        title: "Payout Ratios",
                        url: "/admin/payout-ratios",
                    },
                    {
                        title: "Management Fees",
                        url: "/admin/management-fee-ratios",
                    },
                    {
                        title: "Cleaning Rates",
                        url: "/admin/cleaning-rates",
                    },
                    {
                        title: "Business Fees",
                        url: "/admin/business-fees",
                    },
                    {
                        title: "Blocked Dates",
                        url: "/admin/blocked",
                    },
                    {
                        title: "Airbnb Reviews",
                        url: "/admin/airbnb-reviews",
                    },
                    {
                        title: "Tags",
                        url: "/admin/tags",
                    },
                    {
                        title: "Municipality Sections",
                        url: "/admin/municipality-sections",
                    },
                    {
                        title: "Addresses",
                        url: "/admin/addresses",
                    },
                    {
                        title: "Owner Groups",
                        url: "/admin/owner-groups",
                    },
                ],
            },
        ],
    },
    {
        title: "Other",
        items: [
            {
                title: "Reports",
                url: "/admin/reports",
                icon: FileTextIcon,
            },
            {
                title: "Users",
                url: "/admin/users",
                icon: UsersIcon,
            },
            {
                title: "Filing credentials",
                url: "/admin/filing-credentials",
                icon: KeyRoundIcon,
            },
        ],
    },
];
